import { render } from "./how-it-works-steps.vue?vue&type=template&id=05b52ff9&scoped=true&ts=true"
import script from "./how-it-works-steps.vue?vue&type=script&lang=ts"
export * from "./how-it-works-steps.vue?vue&type=script&lang=ts"

import "./how-it-works-steps.vue?vue&type=style&index=0&id=05b52ff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b52ff9"]])

export default __exports__